import React, { useEffect, useState } from "react";
import api from "APP_ROOT/api";
import { Col, Row } from "react-bootstrap";
import { NoteTooltip } from "MODULES/shared/components";
import { shortDate } from "LIB/formatters/date";

function ApiKeys() {
  const [results, setResults] = useState({});

  useEffect(() => {
    api.tenant.find().then(({ data }) => {
      setResults(data || {});

      return function cleanup() {};
    });
  }, []);

  const onClick = () =>
    api.tenant.create().then(({ data }) => {
      setResults(data);
    });

  return (
    <Col>
      <Row>
        <Col md={12}>
          <div className="page-header page-header-bar">
            <h1>
              <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
                <button
                  key="create-api-key"
                  onClick={onClick}
                  className="btn btn-primary"
                >
                  <span>
                    <i className="fa fa-fw fa-plus" />
                    <span>Create API Key</span>
                  </span>
                </button>
              </div>
              API KEY{" "}
            </h1>
          </div>
        </Col>
      </Row>
      <Row>
        <div className="well">
          Please use the following keys using Basic Auth.
        </div>
      </Row>
      <Row>
        {results &&
          results.un && [
            <Col md={3}>Username: {results.un} </Col>,
            <Col md={2}>
              PW: {results.pw || "********"}
              <span className="text-right">
                <NoteTooltip
                  placement="right"
                  icon="fa-info-circle"
                  color="rgba(255, 255, 255, 0.25)"
                  note={
                    "For Security purposes we do not allow the password to be displayed.  Please copy the pw and store safely once created."
                  }
                />
              </span>
            </Col>,
            <Col md={3}>Expires: {shortDate(results.expires_at)}</Col>
          ]}
      </Row>
    </Col>
  );
}

export default ApiKeys;



// WEBPACK FOOTER //
// ./app/modules/Admin/ApiKeys/ApiKeys.jsx